// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-preview-mobile-Z36AP9 .semi-image-preview-footer{opacity:0}.image-preview-mobile-Z36AP9.semi-image-preview{background-color:#000}.image-preview-mobile-Z36AP9 .semi-image-preview-header-close{display:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"image-preview-mobile": `image-preview-mobile-Z36AP9`,
	"imagePreviewMobile": `image-preview-mobile-Z36AP9`
};
export default ___CSS_LOADER_EXPORT___;
